import { RootState } from 'editor/src/store/index';

const getSidebarTabsCount = (state: RootState) =>
  state.editorModules.sidebar.baseTabs.length + state.editorModules.sidebar.pluginTabs.length;

export default getSidebarTabsCount;
